import { useRef, type DragEvent } from "react";
import { type WidgetPreset } from "../../../../nodes/widgets";
import { StickerArt } from "../../../../nodes/widgets/StickerArt";

/** The art or face the widget renders on the canvas, scaled into a box. */
export function WidgetPreview({
  preset,
  width,
  height,
  inset = 12,
}: {
  preset: WidgetPreset;
  width: number;
  height: number;
  inset?: number;
}) {
  const scale = Math.min(
    (width - inset) / preset.defaultWidth,
    (height - inset) / preset.defaultHeight,
  );
  const Preview = preset.preview;
  return (
    <span className="flex h-full w-full items-center justify-center">
      <span
        inert
        className="pointer-events-none block shrink-0"
        style={{
          width: preset.defaultWidth,
          height: preset.defaultHeight,
          transform: `scale(${scale})`,
        }}
      >
        {preset.html ? (
          <StickerArt markup={preset.html} scope={`pick-${preset.id}`} />
        ) : Preview ? (
          <Preview />
        ) : null}
      </span>
    </span>
  );
}

/** Drag a widget onto the board — the same transfer the gallery used. */
export function startWidgetDrag(
  preset: WidgetPreset,
  e: DragEvent<HTMLElement>,
) {
  e.dataTransfer.setData("application/widget-preset", preset.id);
  e.dataTransfer.effectAllowed = "move";
}

export function useWidgetDrag() {
  const ref = useRef<HTMLDivElement>(null);
  return ref;
}
